// extracted by mini-css-extract-plugin
export default {"searchPatient":"SearchPatient_searchPatient__b+kjE","input":"SearchPatient_input__RGgte","title":"SearchPatient_title__778Jb","orderLink":"SearchPatient_orderLink__TQVKi"};